import React from 'react';

export default function Profilo() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Il tuo profilo</h1>
      <p>Questa pagina mostrerà le informazioni del tuo account.</p>
    </div>
  );
}
